import { apiEndpoint } from "./apiEndpoints.js";
import apiInterceptor from "./apiInterceptor.js";

export function getInterviewDetails(guid) {
  return apiInterceptor.get(apiEndpoint.interviewDetails + guid);
}

export function getInterviewQuestions(guid) {
  return apiInterceptor.get(apiEndpoint.interviewDetails + guid + '/questions');
}
